'use client';

import React, { Dispatch, SetStateAction } from 'react';

import { ArticleCategory } from '~types/Article.types';

export const CategoryContext = React.createContext<{
  category?: ArticleCategory;
  setCategory: Dispatch<SetStateAction<ArticleCategory | undefined>>;
}>({ category: undefined, setCategory: () => {} });
